import React from 'react';
import {Empty, Modal} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import {Scrollbars} from "react-custom-scrollbars";
import {uuid} from '../../../utils';

export default class SelectImg extends BaseComponent {
    static defaultProps = {
        imgAll: [],
        onOk: () => {
        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            checkedPic: '',
            visible: false,
            checkedKey: 0,
        };
    }

    componentWillMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

    showModal = () => {
        this.setState({visible: true});
    };

    handleCancelContent = () => {
        this.setState({visible: false});
    };

    handleOkContent = (checkedPic) => {
        if (checkedPic) {
            this.props.getImgChoose && this.props.getImgChoose(checkedPic)
        }
        this.setState({
            visible: false
        })
    };

    render() {
        const {visible} = this.state;
        const {imgAll} = this.props;
        if (!(imgAll && imgAll.length)) {
            return <></>;
        }
        return (
            <Modal title={'选择图片'} width={400} visible={visible} onOk={() => {
                this.handleOkContent(this.state.checkedPic)
            }}
                   onCancel={this.handleCancelContent}
                   bodyStyle={{height: 365}}>
                <Scrollbars style={{width: 360}} autoHide>
                    <div>
                        {
                            imgAll ? (<div key={uuid()}>
                                {
                                    imgAll && imgAll.length && imgAll.map((item, index) => {
                                        return (
                                            <div key={uuid()} className={'checkedImg'}
                                                 style={{
                                                     padding: 3,
                                                     marginRight: 20,
                                                     marginBottom: '24px',
                                                 }}
                                                 onClick={(e) => {
                                                     imgAll.forEach(i => {
                                                         i.checked = false;
                                                     })
                                                     item.checked = !item.checked;
                                                     if(item.checked) {
                                                         this.setState({checkedPic: imgAll[index].path})
                                                     }
                                                 }}>
                                                <img
                                                    src={imgAll[index].path}
                                                    key={index} style={{
                                                    width: '330px',
                                                    height: '198px',
                                                    objectFit: "contain",
                                                    border: '3px solid',
                                                    borderColor: this.state.checkedPic === imgAll[index].path ? '#0050B3' : "transparent",
                                                }}>
                                                </img>
                                            </div>
                                        )
                                    })
                                }
                            </div>) : <Empty/>
                        }

                        <style>
                            {`
                       .active{
                         border:1px solid red;
                       }
                    `}
                        </style>
                    </div>

                </Scrollbars>
            </Modal>
        )
    }
}